import { track } from '@/lib/analytics'
import type { getStreamStats } from '@/lib/debug/stream-stats'

const SAMPLE_STORAGE_KEY = 'orderx:stream-performance-sample-v1'
const PROD_SAMPLE_RATE = 0.01

type StreamSample = ReturnType<typeof getStreamStats>['samples'][number]

export function isStreamPerformanceSampled(random = Math.random): boolean {
  if (typeof window === 'undefined' || process.env.NEXT_PUBLIC_ENV !== 'prod') return false

  try {
    const stored = window.sessionStorage.getItem(SAMPLE_STORAGE_KEY)
    if (stored !== null) return stored === '1'
    const sampled = random() < PROD_SAMPLE_RATE
    window.sessionStorage.setItem(SAMPLE_STORAGE_KEY, sampled ? '1' : '0')
    return sampled
  } catch {
    return false
  }
}

export function reportStreamPerformanceSample(sample: StreamSample): void {
  if (process.env.NEXT_PUBLIC_ENV !== 'prod') return
  void track('ws_stream_performance', sample)
}
